import {
  REQUEST_CREATE_JUDGEMENT_ADD,
  REQUEST_GET_JUDGEMENT_ADD,
  SET_JUDGEMENT_ADD,
  REQUEST_CREATE_EXPERTISE_RAPORT,
  REQUEST_GET_EXPERTISE_RAPORT,
  SET_EXPERTISE_RAPORT,
  REQUEST_CREATE_JUDGEMENT_ON_MERITS,
  REQUEST_GET_JUDGEMENT_ON_MERITS,
  SET_JUDGEMENT_ON_MERITS,
  REQUEST_CREATE_JUDGEMENT_APPEAL,
  REQUEST_GET_JUDGEMENT_APPEAL,
  SET_JUDGEMENT_APPEAL,
  REQUEST_GET_DAHIR_AMOUNT,
  SET_DAHIR_AMOUNT,
  REQUEST_GET_CIVIL_PROCEEDING,
  SET_CIVIL_PROCEEDING,
  REQUEST_INSERT_DAHIR_AMOUNT_JOM,
  REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO,
  SET_DAHIR_AMOUNT_CORPO,
  REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION,
  REQUEST_UPDATE_CONTESTATION,
  REQUEST_UPLOAD_CONTESTATION_DOCUMENTS,
  REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL,
  SET_JUDGEMENT_ON_MERITS_APPEAL,
  REQUEST_GET_EXPERTISE_REPORT_APPEAL,
  SET_EXPERTISE_RAPORT_APPEAL,
  REQUEST_GET_JUDGEMENT_ADD_APPEAL,
  SET_JUDGEMENT_ADD_APPEAL,
  REQUEST_CREATE_CIVIL_PROCEEDING,
  REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD,
  REQUEST_ADD_DOCUMENT_CLAIM,
  REQUEST_ADD_SUPPORT_DOCUMENT,
  REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT,
  REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT,
  REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT,
  REQUEST_UPDATE_JUDGEMENT_ADD,
  REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT,
  REQUEST_UPDATE_LAWYER_FIRM_REFERENCE,
  REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE,
  SET_JUDGEMENT_ON_MERITS_MULTIPLE,
  REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE,
  SET_APPEAL_ON_MERITS_MULTIPLE,
  RESET_JUDGEMENT_ADD,
  RESET_EXPERT_REPORT,
  RESET_JUDGEMENT_ON_MERITS,
  RESET_MULTIPLE_JUDGEMENT_ON_MERITS,
  SET_LOCKED_CLAIM,
  RESET_LAWYER_LEGAL_PROCEEDING,
  RESET_LAWYER_STEPS,
} from 'containers/LawyerLegalProceedingsPage/constants';
import {
  IJudgementAdd,
  JudgementOnMeritsType,
  IAppealPayload,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { Moment } from 'moment-timezone';

export const requestCreateJudgementAdd = (
  payload: {},
  callback: Function,
  handleError: Function,
) => ({
  type: REQUEST_CREATE_JUDGEMENT_ADD,
  payload,
  callback,
  handleError,
});

export const requestGetJudgementAdd = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ADD,
  claimId,
  procedureType,
  judiciaryProcessId,
});

export const requestGetJudgementAddAppeal = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ADD_APPEAL,
  claimId,
  procedureType,
  judiciaryProcessId,
});

export const setJudgementAdd = (judgementAdd: IJudgementAdd) => ({
  type: SET_JUDGEMENT_ADD,
  judgementAdd,
});

export const setJudgementAddAppeal = (judgementAddAppeal: IJudgementAdd) => ({
  type: SET_JUDGEMENT_ADD_APPEAL,
  judgementAddAppeal,
});

export const requestInsertDahirAmountJom = (payload: {}) => ({
  type: REQUEST_INSERT_DAHIR_AMOUNT_JOM,
  payload,
});
export const requestGetDahirAmountCorpo = (claimId: number) => ({
  type: REQUEST_GET_DAHIR_AMOUNT_JOM_CORPO,
  claimId,
});
export const setDahirAmountCorpo = (dahirAmountCorpo: {}) => ({
  type: SET_DAHIR_AMOUNT_CORPO,
  dahirAmountCorpo,
});
export const resetJudgementAdd = () => ({
  type: RESET_JUDGEMENT_ADD,
});
export const resetExpertReport = () => ({
  type: RESET_EXPERT_REPORT,
});
export const resetJudgementOnMerits = () => ({
  type: RESET_JUDGEMENT_ON_MERITS,
});
export const resetMultipleJudgementOnMerits = () => ({
  type: RESET_MULTIPLE_JUDGEMENT_ON_MERITS,
});
export const requestCreateExpertiseRaport = (
  payload: {},
  callback: Function,
  handleError: Function,
) => ({
  type: REQUEST_CREATE_EXPERTISE_RAPORT,
  payload,
  callback,
  handleError,
});

export const requestGetExpertiseRaport = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_EXPERTISE_RAPORT,
  claimId,
  procedureType,
  judiciaryProcessId,
});

export const requestGetExpertiseReportAppeal = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_EXPERTISE_REPORT_APPEAL,
  claimId,
  procedureType,
  judiciaryProcessId,
});

export const setExpertiseRaport = (expertiseRaport: ExpertReportType) => ({
  type: SET_EXPERTISE_RAPORT,
  expertiseRaport,
});

export const setExpertiseRaportAppeal = (
  expertiseRaportAppeal: ExpertReportType,
) => ({
  type: SET_EXPERTISE_RAPORT_APPEAL,
  expertiseRaportAppeal,
});

export const requestCreateJudgementOnMerits = (
  payload: {},
  callback: Function,
) => ({
  type: REQUEST_CREATE_JUDGEMENT_ON_MERITS,
  payload,
  callback,
});

export const requestGetJudgementOnMerits = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ON_MERITS,
  claimId,
  procedureType,
  judiciaryProcessId,
});
export const requestGetJudgementOnMeritsMultiple = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ON_MERITS_MULTIPLE,
  claimId,
  procedureType,
  judiciaryProcessId,
});
export const requestGetAppealOnMeritsMultiple = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_APPEAL_ON_MERITS_MULTIPLE,
  claimId,
  procedureType,
  judiciaryProcessId,
});
export const requestGetJudgementOnMeritsAppeal = (
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_GET_JUDGEMENT_ON_MERITS_APPEAL,
  claimId,
  procedureType,
  judiciaryProcessId,
});
export const requestGetCivilProceeding = (claimId: number) => ({
  type: REQUEST_GET_CIVIL_PROCEEDING,
  claimId,
});
export const setCivilProceeding = (civilProceeding: any) => ({
  type: SET_CIVIL_PROCEEDING,
  civilProceeding,
});
export const requestCreateCivilProceeding = (
  civilProceeding: any,
  successCallback: Function,
) => ({
  type: REQUEST_CREATE_CIVIL_PROCEEDING,
  civilProceeding,
  successCallback,
});
export const setJudgementOnMerits = (
  judgementOnMerits: JudgementOnMeritsType,
) => ({
  type: SET_JUDGEMENT_ON_MERITS,
  judgementOnMerits,
});
export const setJudgementOnMeritsMultiple = (
  judgementOnMeritsMultiple: any,
) => ({
  type: SET_JUDGEMENT_ON_MERITS_MULTIPLE,
  judgementOnMeritsMultiple,
});
export const setAppealOnMeritsMultiple = (appealOnMeritsMultiple: any) => ({
  type: SET_APPEAL_ON_MERITS_MULTIPLE,
  appealOnMeritsMultiple,
});
export const setJudgementOnMeritsAppeal = (
  judgementOnMeritsAppeal: JudgementOnMeritsType,
) => ({
  type: SET_JUDGEMENT_ON_MERITS_APPEAL,
  judgementOnMeritsAppeal,
});
export const requestCreateJudgementAppeal = (
  payload: IAppealPayload,
  callback: Function,
) => ({
  type: REQUEST_CREATE_JUDGEMENT_APPEAL,
  payload,
  callback,
});
export const requestGetJudgementAppeal = (claimId: number) => ({
  type: REQUEST_GET_JUDGEMENT_APPEAL,
  claimId,
});
export const setJudgementAppeal = (judgementAppeal: IAppealPayload) => ({
  type: SET_JUDGEMENT_APPEAL,
  judgementAppeal,
});

export const requestGetDahirAmount = (
  victimKeys: string[],
  deceasedVictimKeys: string[],
) => ({
  type: REQUEST_GET_DAHIR_AMOUNT,
  data: { victimKeys, deceasedVictimKeys },
});

export const setDahirAmount = (dahirAmount: { data: [] }) => ({
  type: SET_DAHIR_AMOUNT,
  dahirAmount,
});

export const requestCreateJudgementOnMeritsContestation = (
  payload: {},
  successCallback: Function,
) => ({
  type: REQUEST_CREATE_JUDGEMENT_ON_MERITS_CONTESTATION,
  payload,
  successCallback,
});

export const updateContestation = (
  id: any,
  audienceDate: Moment | null,
  lawyerOpinion: String,
  claimId: number,
  procedureType: string,
  judiciaryProcessId: number,
  validator: string,
  status: string,
  claimNumber: string,
  isLawyer: boolean,
  isModified: boolean,
  successCallback: Function,
  rejectionReason: string,
  globalContestationInfo: any,
) => ({
  type: REQUEST_UPDATE_CONTESTATION,
  id,
  audienceDate,
  lawyerOpinion,
  claimId,
  procedureType,
  judiciaryProcessId,
  validator,
  status,
  claimNumber,
  isLawyer,
  isModified,
  successCallback,
  rejectionReason,
  globalContestationInfo,
});

export const requestUploadContestationDocument = (
  contestationDocuments: any,
  claimNumber: string,
  claimId: number,
  judiciaryProcessId: number,
  validator: string,
  contestationDocsToUpdate: any,
  procedureType: string,
  isLawyer: boolean,
  successCallback: Function,
  contestationNatureId: number,
  jmcId: number,
) => ({
  type: REQUEST_UPLOAD_CONTESTATION_DOCUMENTS,
  contestationDocuments,
  claimNumber,
  claimId,
  judiciaryProcessId,
  validator,
  contestationDocsToUpdate,
  procedureType,
  isLawyer,
  successCallback,
  contestationNatureId,
  jmcId,
});
export const requestCreateMultipleJudgementAdd = (
  payload: {},
  callback: Function,
) => {
  return {
    type: REQUEST_CREATE_MULTIPLE_JUDGEMENT_ADD,
    payload,
    callback,
  };
};

export const requestAddDocumentClaim = (payload: {}) => ({
  type: REQUEST_ADD_DOCUMENT_CLAIM,
  payload,
});

export const requestAddSupportDocument = (payload: {}) => ({
  type: REQUEST_ADD_SUPPORT_DOCUMENT,
  payload,
});

export const requestCivilPartySupportDocument = (payload: {}) => ({
  type: REQUEST_CIVIL_PARTY_SUPPORT_DOCUMENT,
  payload,
});

export const requestAddExpertiseSupportDocument = (payload: {}) => ({
  type: REQUEST_ADD_EXPERT_REPORT_SUPPORT_DOCUMENT,
  payload,
});

export const requestAddJudgementOnMeritsSupportDocument = (payload: {}) => ({
  type: REQUEST_ADD_JUDGEMENT_ON_MERITS_SUPPORT_DOCUMENT,
  payload,
});

export const requestUpdateJudgementAdd = (payload: {}, callback: Function) => ({
  type: REQUEST_UPDATE_JUDGEMENT_ADD,
  payload,
  callback,
});
export const requestUpdateJudgementAddDocument = (
  payload: {},
  callback: Function,
) => ({
  type: REQUEST_UPDATE_JUDGEMENT_ADD_DOCUMENT,
  payload,
  callback,
});

export const requestUpdateFirmReference = (
  payload: {},
  callback: Function,
) => ({
  type: REQUEST_UPDATE_LAWYER_FIRM_REFERENCE,
  payload,
  callback,
});
export const setLockedClaim = (claimNumber: string) => {
  return {
    type: SET_LOCKED_CLAIM,
    claimNumber,
  };
};
export const resetLegalProceeding = () => {
  return {
    type: RESET_LAWYER_LEGAL_PROCEEDING,
  };
};
export const resetLawyerSteps = () => {
  return {
    type: RESET_LAWYER_STEPS,
  };
};
